import { render, staticRenderFns } from "./SigatokaRanking.vue?vue&type=template&id=6158f163&scoped=true"
import script from "./SigatokaRanking.vue?vue&type=script&lang=js"
export * from "./SigatokaRanking.vue?vue&type=script&lang=js"
import style0 from "./SigatokaRanking.vue?vue&type=style&index=0&id=6158f163&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6158f163",
  null
  
)

export default component.exports